// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_865aa65","titleWrap":"_ea5119a","title":"_b5aa868","type":"_77bc998","buttonsWrap":"_2ed68bf","unregister":"_7de9685"};